import React, { useEffect } from "react";

import "./dashboardStyles.css";

import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmployerConfig,
  getUserEmployerInfo,
  getUserEmployerMetadata,
} from "../../actions/employer";
import { AccessType, Resource } from "../../authorization/authorization.enum";
import isAuthorized from "../../authorization/authorizationAccess";
import FullScreenLoader from "../../components/fullscreen-loader";
import Notifier from "../../components/notifier";
import { GOR_EMPLOYER_ID } from "../../constants";
import dispatch from "../../middleware";
import { RoutePaths } from "../../models";
import { ReduxState } from "../../reducers";
import { navigateTo } from "../../utils";
import { getRoutes } from "./dashboardRoutes";
import { Menu } from "./menu";
import Toggler from "./toggler";

function hasMinimumOneVendorAccess(resources: { [name: string]: string[] }) {
  return (
    isAuthorized(
      resources,
      Resource.EMPLOYER_PORTAL_VENDORS_ADMIN,
      AccessType.READ
    ) ||
    isAuthorized(
      resources,
      Resource.EMPLOYER_PORTAL_VENDORS_EMPLOYEES,
      AccessType.READ
    ) ||
    isAuthorized(
      resources,
      Resource.EMPLOYER_PORTAL_VENDORS_PAYROLL,
      AccessType.READ
    ) ||
    isAuthorized(
      resources,
      Resource.EMPLOYER_PORTAL_VENDORS_TRANSACTIONS,
      AccessType.READ
    ) ||
    isAuthorized(
      resources,
      Resource.EMPLOYER_PORTAL_VENDORS_ATTENDANCE,
      AccessType.READ
    )
  );
}
function hasMinimumOneEmployerAccess(resources: { [name: string]: string[] }) {
  return (
    isAuthorized(resources, Resource.EMPLOYER_PORTAL_ADMIN, AccessType.READ) ||
    isAuthorized(
      resources,
      Resource.EMPLOYER_PORTAL_EMPLOYEES,
      AccessType.READ
    ) ||
    isAuthorized(
      resources,
      Resource.EMPLOYER_PORTAL_ATTENDANCE,
      AccessType.READ
    ) ||
    isAuthorized(
      resources,
      Resource.EMPLOYER_PORTAL_PAYROLL,
      AccessType.READ
    ) ||
    isAuthorized(
      resources,
      Resource.EMPLOYER_PORTAL_TRANSACTIONS,
      AccessType.READ
    )
  );
}

export function Dashboard() {
  const storeDispatch = useDispatch();
  const loading: boolean = useSelector(
    (state: ReduxState) => state.login.loading
  );
  const resources = useSelector(
    (state: ReduxState) => state.login?.userDetails?.resources || {}
  );
  const employerConfig = useSelector(
    (state: ReduxState) => state.employer.employerConfig
  );
  const employerAdminEmployerId = useSelector(
    (state: ReduxState) => state.login.userDetails.employerId
  );

  const shouldShowDashboardRoute = employerAdminEmployerId === GOR_EMPLOYER_ID;

  function autoRouteNavigate() {
    if (
      !hasMinimumOneEmployerAccess(resources) &&
      hasMinimumOneVendorAccess(resources)
    ) {
      navigateTo(RoutePaths.VENDORS);
    }
  }

  useEffect(() => {
    dispatch(storeDispatch, getUserEmployerInfo());
    dispatch(storeDispatch, getEmployerConfig(), false);
    dispatch(storeDispatch, getUserEmployerMetadata());
    autoRouteNavigate();
  }, []);

  return (
    <div className="dashboard">
      <div className="menu-wrapper">
        <Menu />
      </div>
      <div className="content">
        <FullScreenLoader active={loading} />
        <div className="header">
          <Toggler />
        </div>
        <div className="route-area">
          {getRoutes(employerConfig, shouldShowDashboardRoute)}
        </div>
      </div>
      <Toaster position="bottom-right" reverseOrder={false} />
      <Notifier />
    </div>
  );
}
